// extracted by mini-css-extract-plugin
module.exports = {"landing-footer":"PxFooter_landing-footer__n6VWI","terms-conditions":"PxFooter_terms-conditions__1UCu4","pixel-canvas-year":"PxFooter_pixel-canvas-year__1q1rK"};